import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Icon } from '../../Atoms';
import { IconText } from '../../Molecules';


export default /*@__PURE__*/_defineComponent({
  __name: 'OfflineBanner',
  props: {
    message: {},
    onClick: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "offline-banner",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode(_unref(IconText), { "icon-name": "OfflineIndicator" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.message), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(Icon), {
      class: "info",
      "icon-name": "info",
      md: ""
    })
  ]))
}
}

})